<template>
  <p class="c-footer__copyright">
    Copyright © {{ copyrightYear }} Center for Internet Security&reg;
  </p>
</template>

<script>
export default {
  name: 'CIS-Footer-Copyright',
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    copyrightYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="scss">
.c-footer__links {
  .c-footer__copyright {
    font-size: 1.4rem;
    margin: 0 0 1rem 0;
    padding-right: 1rem;

    @include desktop-up {
      display: inline-block;
      margin: 0;
    }

    &:after {
      @include desktop-up {
        content: '|';
        position: relative;
        right: -1rem;
      }
    }
  }
}
</style>
